"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateArrayOfYears = void 0;
const generateArrayOfYears = (diff) => {
    const years = [];
    const max = new Date().getFullYear();
    const min = max - diff;
    for (let i = max; i >= min; i--) {
        years.push(i);
    }
    return years;
};
exports.generateArrayOfYears = generateArrayOfYears;
